import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./FilterBars.module.css";
import DateRange from "./DateRange";

interface DateFilterBarProps {
    startDate: Date | null;
    endDate: Date | null;
    onStartDateChange: (d: Date | null) => void;
    onEndDateChange: (d: Date | null) => void;
    maxRangeDays?: number;
    canApply: boolean;
    applying: boolean;
    onApply: () => void;
    onReset: () => void;
}

/**
 * Period-only filter bar for the owner layout of the Mobile-app tab.
 * The applied date range drives BOTH the app-download block and the
 * visitor/track KPIs below — hence it sits on its own at the very top.
 */
const DateFilterBar: React.FC<DateFilterBarProps> = ({
    startDate,
    endDate,
    onStartDateChange,
    onEndDateChange,
    maxRangeDays,
    canApply,
    applying,
    onApply,
    onReset,
}) => {
    const { t } = useTranslation();
    const tt = t as unknown as (k: string) => string;

    return (
        <section className={styles.card} aria-label={tt("analyticsPeriod")}>
            <div className={styles.header}>
                <h3 className={styles.title}>{tt("analyticsPeriod")}</h3>
                <p className={styles.hint}>{tt("analyticsPeriodHint")}</p>
            </div>
            <div className={styles.dateField}>
                <DateRange
                    start={startDate}
                    end={endDate}
                    onStartChange={onStartDateChange}
                    onEndChange={onEndDateChange}
                    maxRangeDays={maxRangeDays}
                />
            </div>
            <div className={styles.actions}>
                <button type="button" className={styles.applyButton} disabled={!canApply || applying} onClick={onApply}>
                    {applying ? tt("loading") : tt("apply")}
                </button>
                <button type="button" className={styles.resetButton} onClick={onReset}>
                    {tt("reset")}
                </button>
            </div>
        </section>
    );
};

export default DateFilterBar;
